export function getDifferenceInDays(startDate: Date, endDate: Date): number {
  const start = new Date(startDate)
  start.setHours(0, 0, 0, 0)
  const end = new Date(endDate)
  end.setHours(0, 0, 0, 0)

  return (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
}
